/**
 * @Author: Nenad Brcic
 * @Date: 27.05.16
 * @Email: neno@neno.ch
 */

import React, {Component} from 'react';
import styles from './AdvancedSearchForm.scss';
import CSSModules from 'react-css-modules';
import AdvancedSearchField from './AdvancedSearchField';
import Icon from '../../shared/Icon';
import localize from '../../../localize';

class AdvancedSearchForm extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount(){
        this.fields = {};
        for(let i = 0; i < this.props.searchFields.length; i++) {
            const f = this.props.searchFields[i];
            this.fields[f] = document.getElementById(`extended-search-field-${f}`);
        }
    }

    componentDidUpdate() {
        if (this.props.doReset) {
            this.resetSearch();
        }
    }

    handleSearch(e) {
        e.preventDefault();

        let searchObj = {};
        this.props.searchFields.map((f) => (
            searchObj[f] = this.fields[f].value
        ));
        this.props.handleSearch(searchObj);
    }

    resetSearch () {
        this.props.searchFields.map((f) => this.fields[f].value = '');
    }

    toggleAdvancedSearch = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.toggleAdvancedSearch();
    };
    
    render() {
        const lang = this.props.lang;
        function l(key) {
            const str = `${lang}.components.Navigation.${key}`;
            return localize(str);
        }

        const advancedSearchFields = this.props.searchFields.map(function (field) {
            return (
                <AdvancedSearchField key={ field }
                                     field={ field }
                                     placeholderText={ l(`search.${field}`) }
                />
            )
        });

        return (
            <form onSubmit={ (e) => this.handleSearch(e) }>
                <fieldset>
                    <legend styleName="toggle" onClick={ (e) => this.toggleAdvancedSearch(e) }>
                        { l("extendedSearch") }
                        <Icon className={ this.props.isAdvancedSearch ? "is-open" : null }
                              styleName="icon-toggle"
                              icon="Vitra_Next.svg"
                        />
                        <input type="hidden" ref="isAdvancedSearch" />
                    </legend>
                    <div styleName={ this.props.isAdvancedSearch ? 'extended-search-is-open' : 'extended-search' } >
                        <ul styleName="extended-search-fields">
                            { advancedSearchFields }
                        </ul>
                        <button styleName="extended-search-submit" type="submit">
                            { l('search.search') }
                            <Icon styleName="icon-next" icon="Vitra_Next.svg" />
                        </button>
                    </div>
                </fieldset>
            </form>
        )
    }
};

export default CSSModules(AdvancedSearchForm, styles);


// WEBPACK FOOTER //
// ./app/components/Main/AdvancedSearchForm/index.jsx